module.exports = __webpack_public_path__ + "static/media/basicRingtone.ac4f007f.wav";